export const getSelectSizeClass = (selectClassName) =>
    selectClassName !== undefined ? selectClassName : 'form-select-sm';

export const getOptionKey = (option) =>
    option?.ulid ?? option?.value ?? option?.name ?? option?.imo_number ?? option?.organization_name ?? option?.option;

export const getBorderLessOptionLabel = (label, option) => {
    if (label === 'Vessel IMO') {
        return option.imo_number;
    }
    if (label === 'Customer Name') {
        return option.organization_name;
    }
    return option.name;
};

export const getDefaultOptionLabel = (label, option) => {
    if (label === 'Vessel IMO') {
        return option.imo_number;
    }
    if (label === 'Compliance Check Status') {
        return option.option;
    }
    if (label === 'Customer Name') {
        return option.organization_name;
    }
    return option.name;
};

export const getConstantSelectClassName = (props) => {
    const sizeClass = getSelectSizeClass(props.selectClassName);
    if (props.disabled) {
        return `form-select ${sizeClass} border-none`;
    }
    return `form-select ${sizeClass} ${props.error ? 'border-error-700' : ''}`;
};

export const getBorderLessSelectClassName = (props) => {
    if (props.disabled) {
        return `form-select form-select-borderLess border-none`;
    }
    return `form-select form-select-borderLess ${props.error ? 'border-error-700' : ''}`;
};
